// Resolves the currency for a review entry: prefer the ai-entries item's own currencyId,
// then fall back to the organization's base currency, then to '' as a last resort. Used by
// both the detail form prefill (`useReviewEntryDataFormDefaultValues`) and the bulk validate
// payload builder (`buildBulkValidateReviewEntryPayload`) to keep the two paths in sync.
export const getReviewEntryCurrencyId = (
  itemCurrencyId: string | undefined,
  organizationBaseCurrencyId: string | undefined,
): string => itemCurrencyId ?? organizationBaseCurrencyId ?? ''
